import angular from 'angular';
import uiRouter from 'angular-ui-router';
import quotesComponent from './quotes.component';
import dataTable from 'angular-material-data-table';

let quotesModule = angular.module('quotes', [
    uiRouter,
    dataTable
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('quotes', {
        url: '/quotes',
        component: 'quotes',
        parent: 'main',
        data: {
            permissions: {
                only: ['OPERATOR'],
                redirectTo: 'home'
            }
        },
        resolve: {
        }
    });
})
.component('quotes', quotesComponent)
.name;

export default quotesModule;
